<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('diarios')">Ingreso</inertia-link>
      <span class="text-indigo-400 font-medium">/</span>Crear
    </h1>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-4xl">
      <form @submit.prevent="store">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
         <select-input v-model="form.recepcion_id" :error="form.errors.recepcion_id" class="pr-6 pb-8 w-full lg:w-2/4" label="Cliente/Proveedor - Origen / Cantidad / Variedad" required>
            <option v-for="recepcion in recepcions" :key="recepcion.id" :value="recepcion.id">{{ recepcion.nombres }} - {{ recepcion.origen}} / {{recepcion.cantidad}} / {{ recepcion.variedad }}</option>
          </select-input>
          </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">Agregar Ingreso</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import Datepicker from 'vuejs-datetimepicker'


export default {
  metaInfo: { title: 'Crear Ingreso' },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
     Datepicker
  },
  layout: Layout,
  props: {
    recepcions: Array,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        recepcion_id: null,
      }),

    }
  },
  methods: {
    store() {
      this.form.post(this.route('diarios.store'))
    },
  },
}
</script>
